import { Box } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Header from 'features/Onboarding/components/Header';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import OBUpload from 'features/Onboarding/components/OBUpload';
import { getUploadKybFunction } from 'features/Storage/upload';

import { DraftStatutesDocumentFile } from '../../machine/model';
import locales from './locales';

interface DraftStatutesUploadProps {
  onUploadComplete: (documentFile: DraftStatutesDocumentFile) => void;
  companyProfileId: string;
  isMandatee: boolean;
}

const DraftStatutesUpload = asBentoPage<DraftStatutesUploadProps>(
  ({ companyProfileId, isMandatee, Layout, onPrev, onUploadComplete }) => {
    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Header
          title={isMandatee ? locales.title.mandatee : locales.title.nonMandate}
        />

        <Box marginBottom="space-32">
          <OBUpload.Checklist
            checks={[locales.checks.readable, locales.checks.pdf]}
            description={
              isMandatee
                ? locales.aboutTheRules.mandatee
                : locales.aboutTheRules.nonMandatee
            }
            normalFont
          />
        </Box>

        <OBUpload
          onSuccessfulUpload={async ({ bucketName, fileRef, url }) =>
            onUploadComplete({
              firebaseBucket: bucketName,
              firebaseRef: fileRef,
              url,
            })
          }
          uploadFile={getUploadKybFunction(companyProfileId)}
        >
          <OBUpload.UploadZone
            description={locales.upload.description}
            title={
              isMandatee
                ? locales.upload.title.mandatee
                : locales.upload.title.nonMandate
            }
          />
        </OBUpload>
      </Layout>
    );
  },
);

export default DraftStatutesUpload;
